import Paper from '@material-ui/core/Paper'
import axios from 'axios'
import { useState } from 'react'
import { ButtonPrimary } from '../ButtonPrimary'
import { InputFieldText } from '../InputFieldText'

import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'
import { CloudUpload } from 'lucide-react'
import { toast } from 'react-toastify'
import toastError from '../../errors/toastError'
import { getBackendURL } from '../../services/config'
import { i18n } from '../../translate/i18n'
import { useStyles } from './styles'

const MessagesAPI = () => {
  const classes = useStyles()

  const [formMessageTextData] = useState({ token: '', number: '', body: '' })
  const [formMessageMediaData] = useState({ token: '', number: '', medias: '' })
  const [file, setFile] = useState({})

  const getEndpoint = () => {
    return getBackendURL() + '/api/messages/send'
  }

  const handleSendTextMessage = async values => {
    const { number, body } = values
    const data = { number, body }
    var options = {
      method: 'POST',
      url: `${getBackendURL()}/api/messages/send`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${values.token}`
      },
      data
    }

    axios
      .request(options)
      .then(function (response) {
        toast.success('Mensagem enviada com sucesso')
      })
      .catch(function (error) {
        toastError(error)
      })
  }

  const handleSendMediaMessage = async values => {
    try {
      const firstFile = file[0]
      const data = new FormData()
      data.append('number', values.number)
      data.append('body', firstFile.name)
      data.append('medias', firstFile)
      var options = {
        method: 'POST',
        url: `${getBackendURL()}/api/messages/send`,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${values.token}`
        },
        data
      }

      axios
        .request(options)
        .then(function (response) {
          toast.success('Mensagem enviada com sucesso')
        })
        .catch(function (error) {
          toastError(error)
        })
    } catch (err) {
      toastError(err)
    }
  }

  const renderFormMessageText = () => {
    return (
      <Formik
        initialValues={formMessageTextData}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
          setTimeout(async () => {
            await handleSendTextMessage(values)
            actions.setSubmitting(false)
            actions.resetForm()
          }, 400)
        }}
        className={classes.elementMargin}
      >
        {({ isSubmitting }) => (
          <Form className={classes.formContainer}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <InputFieldText
                  label={i18n.t('messagesAPI.textMessage.token')}
                  name="token"
                  autoFocus
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputFieldText
                  label={i18n.t('messagesAPI.textMessage.number')}
                  name="number"
                  // autoFocus
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <InputFieldText
                  label={i18n.t('messagesAPI.textMessage.body')}
                  name="body"
                  // autoFocus
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12} className={classes.textRight}>
                <ButtonPrimary
                  type="submit"
                  color="primary"
                  variant="contained"
                  className={classes.btnWrapper}
                  label={
                    isSubmitting ? (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    ) : (
                      'Enviar'
                    )
                  }
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    )
  }

  const renderFormMessageMedia = () => {
    return (
      <Formik
        initialValues={formMessageMediaData}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
          setTimeout(async () => {
            await handleSendMediaMessage(values)
            actions.setSubmitting(false)
            actions.resetForm()
            document.getElementById('medias').files = null
            document.getElementById('medias').value = null
          }, 400)
        }}
        className={classes.elementMargin}
      >
        {({ isSubmitting }) => (
          <Form className={classes.formContainer}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <InputFieldText
                  label={i18n.t('messagesAPI.mediaMessage.token')}
                  name="token"
                  // autoFocus
                  fullWidth
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputFieldText
                  label={i18n.t('messagesAPI.mediaMessage.number')}
                  name="number"
                  // autoFocus
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <div className={classes.uploadContainer}>
                  <input
                    type="file"
                    name="medias"
                    id="medias"
                    required
                    onChange={e => setFile(e.target.files)}
                    className={classes.hiddenInput}
                  />
                  <label htmlFor="medias">
                    <ButtonPrimary
                      component="span"
                      variant="contained"
                      color="primary"
                      startIcon={<CloudUpload />}
                      label="Selecione"
                    />
                  </label>
                  {file[0] && (
                    <Typography variant="body1" className={classes.fileName}>
                      {file[0].name}
                    </Typography>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} className={classes.textRight}>
                <ButtonPrimary
                  type="submit"
                  color="primary"
                  variant="contained"
                  className={classes.btnWrapper}
                  label={
                    isSubmitting ? (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    ) : (
                      'Enviar'
                    )
                  }
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <Paper className={classes.mainPaper}>
      <Grid container className={classes.boxMessage}>
        <Grid item xs={12} className={classes.boxInstructions}>
          <Typography
            variant="h6"
            color="primary"
            className={classes.subtitleInstructions}
          >
            Instruções
          </Typography>
          <Typography
            component="ul"
            className={classes.descriptionInstructions}
          >
            <Typography component="li">
              Antes de enviar mensagens, é necessário o cadastro do token
              vinculado à conexão que enviará as mensagens. <br />
              Para realizar o cadastro acesse o menu "Conexões", clique no botão
              editar da conexão e insira o token no devido campo.
            </Typography>
            <Typography component="li">
              O campo número aceita dois tipos de informação:
              <Typography component="ul">
                <Typography component="li">
                  <Typography component="span" style={{ fontWeight: 'bold' }}>
                    Número de Whatsapp:
                  </Typography>{' '}
                  Qualquer número de whatsapp completo iniciando pelo código do
                  país (BR=55)
                </Typography>
                <Typography component="li">
                  <Typography component="span" style={{ fontWeight: 'bold' }}>
                    Whatsapp JID:
                  </Typography>{' '}
                  Qualquer identificador do Whatsapp, para grupos ele é um
                  número extenso seguido de @g.us
                </Typography>{' '}
              </Typography>
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <Grid container className={classes.boxMessage}>
        <Grid item xs={12} sm={12} className={classes.box}>
          <Grid item xs={6}>
            <Typography variant="h6" className={classes.subtitle}>
              1. Mensagens de Texto
            </Typography>
            <Typography component="div" className={classes.description}>
              <Typography component="span">
                Seguem abaixo a lista de informações necessárias para envio das
                mensagens de texto:
              </Typography>
              <Typography variant="body1" className={classes.descriptionText}>
                <Typography component="span">
                  <b>Endpoint:</b> {getEndpoint()}
                </Typography>
              </Typography>
              <Typography variant="body1">
                <Typography component="span">
                  <b>Método:</b> POST
                </Typography>
              </Typography>
              <Typography variant="body1" className={classes.descriptionBox}>
                <Typography component="span" style={{ fontWeight: 'bold' }}>
                  Headers
                </Typography>
                <Typography component="span">
                  Authorization ("Bearer " + token cadastrado)
                </Typography>
                <Typography component="span">
                  Content-Type (multipart/form-data)
                </Typography>
              </Typography>
              <Typography component="span" style={{ fontWeight: 'bold' }}>
                Body
              </Typography>
              <pre className={classes.pre}>
                <code>
                  {JSON.stringify(
                    {
                      number: '558599999999',
                      body: 'Sua mensagem',
                      saveOnTicket: true,
                      linkPreview: true
                    },
                    null,
                    2
                  )}
                </code>
              </pre>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.subtitle}>Teste de Envio</Typography>
            {renderFormMessageText()}
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={classes.boxMessage}>
        <Grid item xs={12} sm={12} className={classes.box}>
          <Grid item xs={6} sm={6}>
            <Typography
              variant="h6"
              color="primary"
              className={classes.subtitle}
            >
              2. Mensagens de Media
            </Typography>
            <Typography className={classes.description} component="div">
              <Typography component="span">
                Seguem abaixo a lista de informações necessárias para envio das
                mensagens de mídia:
              </Typography>
              <Typography variant="body1" className={classes.descriptionText}>
                <Typography component="span">
                  <b>Endpoint:</b> {getEndpoint()}
                </Typography>
              </Typography>
              <Typography variant="body1">
                <Typography component="span">
                  <b>Método:</b> POST
                </Typography>
              </Typography>
              <Typography variant="body1" className={classes.descriptionBox}>
                <Typography component="span" style={{ fontWeight: 'bold' }}>
                  Headers
                </Typography>
                <Typography component="span">
                  Authorization ("Bearer " + token cadastrado)
                </Typography>
                <Typography component="span">
                  Content-Type (multipart/form-data)
                </Typography>
              </Typography>
              <Typography variant="body1" className={classes.descriptionBox}>
                <Typography component="span" style={{ fontWeight: 'bold' }}>
                  FormData
                </Typography>
                <Typography component="span">
                  <b>number:</b> 558599999999
                </Typography>

                <Typography component="span">
                  <b>medias: </b> arquivo
                </Typography>

                <Typography component="span">
                  <b>saveOnTicket:</b> true
                </Typography>
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6}>
            <Grid item xs={12}>
              <Typography className={classes.subtitle}>
                Teste de Envio
              </Typography>
              {renderFormMessageMedia()}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default MessagesAPI
